import { render, staticRenderFns } from "./CustomerPayment.vue?vue&type=template&id=58465522"
import script from "./CustomerPayment.vue?vue&type=script&lang=js"
export * from "./CustomerPayment.vue?vue&type=script&lang=js"
import style0 from "./CustomerPayment.vue?vue&type=style&index=0&id=58465522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports